module.exports = __webpack_public_path__ + "img/dot.aaa49d04.svg";